//
// Copyright (c) 2025 Comcast
//

// build sets of supported nodes and marks from editor's schema
const getSupportedFromSchema = (schema) => {
  const nodeSet = new Set(Object.keys(schema.nodes || {}))
  const markSet = new Set(Object.keys(schema.marks || {}))
  return { nodeSet, markSet }
}

// For these types we show visual mode even though editor doesn't support these types.
// This is possible because encoded version is the same, there is no escaped special characters.
const IGNORED_NODE_TYPES = new Set(['emoji'])

// returns true if ADF json has any Node or Mark which type
// is absent in the nodes and marks of the editor's schema (panel, mention),
// false otherwise
export const hasAdfJsonUnsupportedTypes = (adfJson, schema) => {
  const { nodeSet, markSet } = getSupportedFromSchema(schema)
  let bad = false

  const walk = (node) => {
    if (bad || !node) {
      return
    }
    if (!nodeSet.has(node.type) && !IGNORED_NODE_TYPES.has(node.type)) {
      bad = true
      return
    }
    if (node.marks) {
      for (const m of node.marks) {
        if (!markSet.has(m.type)) {
          bad = true
          return
        }
      }
    }
    if (node.content) {
      for (const c of node.content) {
        walk(c)
        if (bad) {
          return
        }
      }
    }
  }

  walk(adfJson)
  return bad
}
